import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {GiiRegistracijaComponent} from "./gii-registracija/gii-registracija.component";
import {KlasifikatoriusComponent} from "./klasifikatorius/klasifikatorius.component";
import {GiiApskaitaComponent} from './gii-apskaita/gii-apskaita.component';
import {AtaskPerziuraPilnaComponent} from './gii-apskaita/atask-perziura-pilna/atask-perziura-pilna.component';

const routes: Routes = [
  { path: "gii-registracija", component: GiiRegistracijaComponent },
  { path: "klasifikatorius", component: KlasifikatoriusComponent },
  { path: "gii-apskaita", component: GiiApskaitaComponent },
  { path: "gii-apskaita/ataskaita/perziura" + '/:id', component: AtaskPerziuraPilnaComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
